/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcErrorHexagonFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M16.095 2.007h-8.19a2.9 2.9 0 0 0-2.512 1.45L1.298 10.55a2.9 2.9 0 0 0 0 2.9l4.095 7.093a2.9 2.9 0 0 0 2.512 1.45h8.19a2.9 2.9 0 0 0 2.512-1.45l4.095-7.093a2.9 2.9 0 0 0 0-2.9l-4.095-7.093a2.9 2.9 0 0 0-2.512-1.45M12 6.933a.953.953 0 0 0-.953.999l.254 5.335a.7.7 0 0 0 1.397 0l.254-5.335A.954.954 0 0 0 12 6.933m1 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcErrorHexagonFill;
